import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
    selector: 'app-acceso-denegado',
    standalone: true,
    imports: [MatIconModule, MatButtonModule],
    templateUrl: './acceso-denegado.component.html',
})
export class AccesoDenegadoComponent {
    private readonly router = inject(Router);

    volver() {
        this.router.navigate(['/']);
    }
}
